import { render, staticRenderFns } from "./IpadHeadNav.vue?vue&type=template&id=4249dcf6&scoped=true&"
import script from "./IpadHeadNav.vue?vue&type=script&lang=js&"
export * from "./IpadHeadNav.vue?vue&type=script&lang=js&"
import style0 from "./IpadHeadNav.vue?vue&type=style&index=0&id=4249dcf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4249dcf6",
  null
  
)

export default component.exports